export default {
    msg: {
        videoMonitoring: 'Video monitoring',
        server: 'Server',
        serverLoad: 'Load average',
        diskFree: 'Disk free',
        memoryFree: 'Memory free',
        uptime: 'Uptime',
        usedOf: 'used of',
        withoutRestart: 'without restart',
        daysShort: 'd',
        hoursShort: 'h',
        minutesShort: 'min',
        archiveForDay: 'Archive for the day',
        cpuLoad: 'CPU usage',
        free: 'free',
        archiveHistory: 'History',
        recording: 'Recording',
        streamLoading: 'Connecting to camera…',
        streamUnavailable: 'Stream is temporarily unavailable',
        streamReconnecting: 'Reconnecting…',
        retry: 'Retry'
    },
    validation: {
        messages: {
            _default: 'not valid',
            required: 'is required',
            max: 'max length {1}',
            url: 'url is not valid',
            decimal: 'not decimal',
            numeric: 'not numeric',
            min_value: 'min value {1}',
            max_value: 'max value {1}',
            char_name: 'available chars: a-z A-Z 0-9 - _ .',
            repeat_password: 'passwords do not match'
        }
    },
    $vuetify: {
        dataTable: {
            itemsPerPageText: 'Rows per page',
            ariaLabel: {
                sortNone: 'Sort none',
                sortAscending: 'Sort ascending',
                sortDescending: 'Sort descending'
            }
        },
        dataFooter: {
            pageText: '{0}-{1} of {2}',
            itemsPerPageAll: 'All',
            prevPage: 'Prev page',
            nextPage: 'Next page'
        },
        dataIterator: {
            loadingText: 'Loading...'
        },
        noDataText: 'No data',
        datePicker: {
            itemsSelected: '{0} selected'
        }
    }
}
